export const init = () => {
  CUBE.Analytics.enhanced.sparepart.es6.initImpression();
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-sparepart.js